var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import Accordion from "../Accordion";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import ArtGeneratorService from "../../services/ArtGeneratorService";
import "../../styles/AdditionalInformation.css";
import { Select, MenuItem } from '@mui/material';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import { getContactIcon } from "../../utils/contactIcons";
;
function formatPhone(value) {
    var digits = value.replace(/\D/g, '');
    if (digits.length <= 10) {
        return digits.replace(/^(\d{2})(\d{4})(\d{0,4}).*/, '($1) $2-$3').replace(/-$/, '');
    }
    return digits.replace(/^(\d{2})(\d{5})(\d{0,4}).*/, '($1) $2-$3').replace(/-$/, '');
}
function formatEmail(value) {
    return value;
}
function contactPlaceholder(typeId) {
    if (typeId === 'email')
        return 'exemplo@dominio.com';
    if (typeId === 'instagram')
        return '@seuperfil';
    return '(21) 99999-9999';
}
var uidSeq = 0;
var makeUid = function () { return "row-".concat(++uidSeq); };
function buildInfoRows(items) {
    if (items.length === 0)
        return [{ uid: makeUid(), id: '', value: '' }];
    return items.map(function (i) { return ({ uid: makeUid(), id: String(i.id), value: i.value }); });
}
function buildContactRows(items) {
    if (items.length === 0)
        return [{ uid: makeUid(), typeId: 'whatsapp', value: '' }];
    return items.map(function (c) { return ({ uid: makeUid(), typeId: c.typeId, value: c.value }); });
}
function AdditionalInformationStep(_a) {
    var additionalInfos = _a.additionalInfos, contactInfo = _a.contactInfo, onChange = _a.onChange, onNext = _a.onNext, onExport = _a.onExport, isOpen = _a.isOpen, onToggle = _a.onToggle, isValid = _a.isValid;
    var _b = useState([]), infosOptions = _b[0], setInfosOptions = _b[1];
    // Estado local inicializado a partir das props apenas uma vez (por montagem). O componente
    // e remontado (via `key` no ArtGenerator) quando o usuario troca de arte/entra em edicao,
    // entao nao ha necessidade de um efeito re-sincronizando a partir das props a cada mudanca -
    // isso e o que causava o vai-e-volta com o pai (linhas apagadas, loop infinito no MUI Select).
    var _c = useState(function () { return buildInfoRows(additionalInfos.filter(function (i) { return i.type === 'info'; })); }), infos = _c[0], setInfos = _c[1];
    var _d = useState([]), svasOptions = _d[0], setSvasOptions = _d[1];
    var _e = useState(function () { return buildInfoRows(additionalInfos.filter(function (i) { return i.type === 'sva'; })); }), svas = _e[0], setSvas = _e[1];
    var _f = useState(function () { return buildContactRows(contactInfo); }), contacts = _f[0], setContacts = _f[1];
    useEffect(function () {
        var active = true;
        ArtGeneratorService.getAdditionalInfos()
            .then(function (_a) {
            var infos = _a.infos, svas = _a.svas;
            if (!active)
                return;
            setInfosOptions(infos);
            setSvasOptions(svas);
        })
            .catch(console.error);
        return function () { active = false; };
    }, []);
    useEffect(function () {
        onChange({
            infos: infos.filter(function (info) { return info.id; }).map(function (i) { return ({ id: i.id, value: i.value, type: 'info' }); }),
            svas: svas.filter(function (sva) { return sva.id; }).map(function (s) { return ({ id: s.id, value: s.value, type: 'sva' }); }),
            contacts: contacts.filter(function (contact) { return contact.typeId && contact.value; }).map(function (c) { return ({ typeId: c.typeId, value: c.value }); })
        });
    }, [infos, svas, contacts]);
    function handleInfoChange(index, field, value, isSva) {
        if (isSva === void 0) { isSva = false; }
        var target = isSva ? __spreadArray([], svas, true) : __spreadArray([], infos, true);
        var item = __assign({}, target[index]);
        if (field === 'id') {
            var options = isSva ? svasOptions : infosOptions;
            var selectedOption = options.find(function (opt) { return opt.id === value; });
            item.id = value;
            item.value = (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) || '';
        }
        else {
            item[field] = value;
        }
        target[index] = item;
        isSva ? setSvas(target) : setInfos(target);
    }
    ;
    function handleContactChange(index, field, value) {
        var updated = __spreadArray([], contacts, true);
        if (field === 'value') {
            var type = updated[index].typeId;
            if (type === 'telefone' || type === 'whatsapp') {
                updated[index][field] = formatPhone(value);
            }
            else if (type === 'email') {
                updated[index][field] = formatEmail(value);
            }
            else {
                updated[index][field] = value;
            }
        }
        else {
            updated[index][field] = value;
        }
        setContacts(updated);
    }
    ;
    function addInfoField(isSva) {
        if (isSva === void 0) { isSva = false; }
        var newItem = { uid: makeUid(), id: '', value: '' };
        isSva ? setSvas(function (prev) { return __spreadArray(__spreadArray([], prev, true), [newItem], false); }) : setInfos(function (prev) { return __spreadArray(__spreadArray([], prev, true), [newItem], false); });
    }
    ;
    function addContactField() {
        setContacts(function (prev) { return __spreadArray(__spreadArray([], prev, true), [{ uid: makeUid(), typeId: '', value: '' }], false); });
    }
    ;
    var contactTypes = [
        { value: 'whatsapp', label: 'WhatsApp', icon: getContactIcon('whatsapp', { marginRight: 8 }) },
        { value: 'telefone', label: 'Telefone', icon: getContactIcon('telefone', { marginRight: 8 }) },
        { value: 'email', label: 'E-mail', icon: getContactIcon('email', { marginRight: 8 }) },
        { value: 'instagram', label: 'Instagram', icon: getContactIcon('instagram', { marginRight: 8 }) },
    ];
    function isStepValid() {
        var hasValidInfo = infos.some(function (info) { return info.id && info.value; });
        var hasValidSva = svas.some(function (sva) { return sva.id && sva.value; });
        var hasValidContact = contacts.some(function (contact) { return contact.typeId && contact.value; });
        return hasValidInfo || hasValidSva || hasValidContact;
    }
    ;
    function removeInfo(index) {
        setInfos(function (prev) {
            if (prev.length <= 1)
                return prev;
            var newInfos = __spreadArray([], prev, true);
            newInfos.splice(index, 1);
            return newInfos;
        });
    }
    ;
    function removeSva(index) {
        setSvas(function (prev) {
            if (prev.length <= 1)
                return prev;
            var newSvas = __spreadArray([], prev, true);
            newSvas.splice(index, 1);
            return newSvas;
        });
    }
    ;
    function removeContact(index) {
        setContacts(function (prev) {
            if (prev.length <= 1)
                return prev;
            var newContacts = __spreadArray([], prev, true);
            newContacts.splice(index, 1);
            return newContacts;
        });
    }
    ;
    return (_jsxs(Accordion, __assign({ title: "Informa\u00E7\u00F5es Adicionais", name: "additional-information", step: 6, isOpen: isOpen, onToggle: onToggle, isValid: isValid }, { children: [_jsxs("div", __assign({ className: "form-group" }, { children: [_jsxs("label", __assign({ className: "label-default" }, { children: ["Outras informa\u00E7\u00F5es ", infos.length, "/", infosOptions.length] })), infos.map(function (info, index) { return (_jsxs("div", __assign({ style: { display: 'flex', alignItems: 'center', gap: '8px' } }, { children: [_jsxs("select", __assign({ className: "select-art-generator-default", value: info.id, onChange: function (e) { return handleInfoChange(index, 'id', e.target.value); } }, { children: [_jsx("option", __assign({ value: "" }, { children: "Selecione" })), infosOptions.map(function (opt) { return (_jsx("option", __assign({ value: opt.id }, { children: opt.value }), opt.id)); })] })), infos.length > 1 && (_jsx("button", __assign({ type: "button", onClick: function () { return removeInfo(index); }, style: { border: 'none', background: 'none', color: 'rgba(0, 0, 0, 0.60)', cursor: 'pointer' } }, { children: _jsx(RemoveIcon, {}) })))] }), info.uid)); }), _jsxs("button", __assign({ type: "button", onClick: function () { return addInfoField(false); }, disabled: infos.length >= infosOptions.length, className: "more-information-button" }, { children: [_jsx(AddIcon, {}), " Mais informa\u00E7\u00F5es"] }))] })), _jsxs("div", __assign({ className: "form-group" }, { children: [_jsx("span", __assign({ className: "label-default" }, { children: "Informa\u00E7\u00F5es de contato" })), contacts.map(function (contact, index) { return (_jsxs("div", __assign({ className: "contact-row", style: { display: 'flex', alignItems: 'center', gap: '8px' } }, { children: [_jsxs(Select, __assign({ value: contact.typeId, onChange: function (e) { return handleContactChange(index, 'typeId', e.target.value); }, displayEmpty: true, variant: "standard", disableUnderline: true, className: "select-mui-art-generator-default", renderValue: function (selected) {
                                    var typeId = typeof selected === 'string' ? selected : '';
                                    return (_jsxs("div", __assign({ style: { display: 'flex', alignItems: 'center', gap: '8px' } }, { children: [getContactIcon(typeId), typeId === '' ? 'Selecione o tipo' : typeId.charAt(0).toUpperCase() + typeId.slice(1)] })));
                                } }, { children: [_jsx(MenuItem, __assign({ value: "", className: "menu-item-default" }, { children: _jsx("em", { children: "Selecione o tipo" }) })), contactTypes.map(function (type) { return (_jsxs(MenuItem, __assign({ value: type.value, className: "menu-item-default" }, { children: [type.icon, type.label] }), type.value)); })] })), _jsx("input", { className: "input-art-generator-default", type: "text", value: contact.value, onChange: function (e) { return handleContactChange(index, 'value', e.target.value); }, placeholder: contactPlaceholder(contact.typeId) }), contacts.length > 1 && (_jsx("button", __assign({ type: "button", onClick: function () { return removeContact(index); }, style: { border: 'none', background: 'none', color: 'rgba(0, 0, 0, 0.60)', cursor: 'pointer' }, "aria-label": "Remover contato" }, { children: _jsx(RemoveIcon, {}) })))] }), contact.uid)); }), _jsxs("button", __assign({ type: "button", onClick: addContactField, className: "more-information-button", disabled: contacts.length >= contactTypes.length }, { children: [_jsx(AddIcon, {}), " Adicionar novo contato"] }))] })), _jsxs("div", __assign({ className: "step-footer", style: { gap: "12px" } }, { children: [_jsxs("button", __assign({ type: "button", className: "continue-button button-with-blue-border", onClick: onNext, disabled: !isStepValid(), style: { display: "flex", alignItems: "center", gap: "6px" } }, { children: [_jsx(BookmarkBorderIcon, { fontSize: "small" }), " Salvar"] })), _jsx("button", __assign({ type: "button", className: "continue-button blue-button", onClick: onExport, disabled: !isStepValid() }, { children: "Finalizar e Exportar" }))] }))] })));
}
export default AdditionalInformationStep;
